import { fork, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  MarketItemShopListRequest, MarketItemShopListResponse, MarketItemShopUpsertRequest,
  PerplayMarketApi, BaseResponse, MarketItemShopInfoRequest, MarketItemShopInfoResponse, MarketItemShopSortUpdateRequest
} from '../../models/src';
import {
  ITEM_SHOP_INFO_REQUEST,
  ITEM_SHOP_LIST_REQUEST, ITEM_SHOP_SORT_UPDATE_REQUEST,
  ITEM_SHOP_UPSERT_REQUEST
} from "../../constants/app/itemShopConstants";

const api = new PerplayMarketApi(config.API_CLIENT);

function* itemShopListRequestSage(payload) {
  try {
    const requestData = new MarketItemShopListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.listType = payload.listType;

    console.log("요청 데이터: ", requestData);

    const res = yield api.apiPerplayMarketItemShopListPost(
      { marketItemShopListRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(res, MarketItemShopListResponse);

    if (data.resultCode !== 200) {
      console.log(data);
      throw Error(`Error: ${data.resultCode}`);
    }

    if (payload.callback) {
      payload.callback(data);
    }
  } catch (e) {
    console.error(e);
    if (payload.error) {
      payload.error(e);
    }
  }
}

function* itemShopUpsertRequestSage(payload) {
  try {
    const requestData = new MarketItemShopUpsertRequest();
    requestData.dataType = payload.dataType;
    requestData.jsonData = payload.jsonData;

    const res = yield api.apiPerplayMarketItemShopUpsertPost(
        { marketItemShopUpsertRequest: requestData },
        () => {},
    );
    const data = api.apiClient.deserialize(res, BaseResponse);

    if (data.resultCode !== 200) {
      console.log(data);
      throw Error(`Error: ${data.resultCode}`);
    }

    if (payload.callback) {
      payload.callback(data);
    }
  } catch (e) {
    console.error(e);
    if (payload.error) {
      payload.error(e);
    }
  }
}

function* itemShopInfoRequestSage(payload) {
  try {
    const requestData = new MarketItemShopInfoRequest();
    requestData.productNo = payload.productNo;

    const res = yield api.apiPerplayMarketItemShopInfoPost(
        { marketItemShopInfoRequest: requestData },
        () => {},
    );
    const data = api.apiClient.deserialize(res, MarketItemShopInfoResponse);

    if (data.resultCode !== 200) {
      console.log(data);
      throw Error(`Error: ${data.resultCode}`);
    }

    if (payload.callback) {
      payload.callback(data);
    }
  } catch (e) {
    console.error(e);
    if (payload.error) {
      payload.error(e);
    }
  }
}

function* itemShopSortUpdateRequestSage(payload) {
  try {
    const requestData = new MarketItemShopSortUpdateRequest();
    requestData.data = payload.data;

    const res = yield api.apiPerplayMarketItemShopSortUpdatePost(
        { marketItemShopSortUpdateRequest: requestData },
        () => {},
    );
    const data = api.apiClient.deserialize(res, BaseResponse);

    if (data.resultCode !== 200) {
      console.log(data);
      throw Error(`Error: ${data.resultCode}`);
    }

    if (payload.callback) {
      payload.callback(data);
    }
  } catch (e) {
    console.error(e);
    if (payload.error) {
      payload.error(e);
    }
  }
}

function* rootSaga() {
  yield all([
    takeEvery(ITEM_SHOP_LIST_REQUEST, itemShopListRequestSage),
    takeEvery(ITEM_SHOP_UPSERT_REQUEST, itemShopUpsertRequestSage),
    takeEvery(ITEM_SHOP_INFO_REQUEST, itemShopInfoRequestSage),
    takeEvery(ITEM_SHOP_SORT_UPDATE_REQUEST, itemShopSortUpdateRequestSage),
  ]);
}

const itemShopSagas = [fork(rootSaga)];
export default itemShopSagas;
